module.exports = __webpack_public_path__ + "static/media/xueshan_plant.386bb768.webp";